// The landing page's lesson cards carry a recorded clip where the lab
// produced one. The poster is the resting state: the source is attached only
// near the viewport, plays while the card is on screen, and pauses when it
// leaves. Explicit autoplay cards play under either motion preference.

import { prefersReducedMotion, whenVisible } from "../anim/helpers";
import { publicUrl } from "../data/paths";

export function mountLessonCards(): void {
  const reduced = prefersReducedMotion();
  for (const video of document.querySelectorAll<HTMLVideoElement>(
    "video[data-card-video]",
  )) {
    const href = video.dataset.cardVideo ?? "";
    video.muted = true; // the property, not the attribute, is what unblocks autoplay
    video.defaultMuted = true;
    video.loop = true;
    video.playsInline = true;
    video.preload = "none";
    video.controls = false;
    video.setAttribute("aria-hidden", "true"); // the card's own text names the lesson
    if (!href || (reduced && !video.autoplay)) continue;

    let visible = false;
    const play = () => {
      if (visible) void video.play().catch(() => {});
    };
    video.addEventListener("loadeddata", play);

    whenVisible(video, {
      rootMargin: "200px",
      threshold: 0.01,
      enter: () => {
        if (video.dataset.attached) return;
        video.dataset.attached = "true";
        if (video.dataset.webm) {
          const webm = document.createElement("source");
          webm.src = publicUrl(video.dataset.webm);
          webm.type = "video/webm";
          video.append(webm);
        }
        const source = document.createElement("source");
        source.src = publicUrl(href);
        source.type = "video/mp4";
        video.append(source);
        video.load();
      },
    });
    whenVisible(video, {
      threshold: 0.35,
      enter: () => {
        visible = true;
        play();
      },
      exit: () => {
        visible = false;
        video.pause();
      },
    });
  }
}
